/**
 * menu-drawer.js
 * 宮崎キャビア1983 モバイルドロワーメニュー
 */
(function () {
  'use strict';

  /* ================================================================
   * STEP 1: drawer と overlay を document.body へ移動する
   *
   * Shopify の .section-header が position:sticky + z-index で
   * stacking context を作るため、その内部の position:fixed 要素は
   * context に閉じ込められ Announcement Bar より下に表示される。
   * body の直接の子に移動することで root stacking context に脱出し、
   * z-index: 1200 が正しく効くようになる。
   * ================================================================ */
  const drawerEl  = document.querySelector('[data-menu-drawer]');
  const overlayEl = document.querySelector('[data-menu-drawer-overlay]');

  if (!drawerEl) return;

  // body の末尾へ移動（defer 実行時点では body は解析済み）
  document.body.appendChild(drawerEl);
  if (overlayEl) document.body.appendChild(overlayEl);

  /* ================================================================
   * STEP 2: 移動後の要素を再取得してイベントを紐付ける
   * ================================================================ */
  const drawer     = document.querySelector('[data-menu-drawer]');
  const overlay    = document.querySelector('[data-menu-drawer-overlay]');
  const toggleBtns = document.querySelectorAll('[data-menu-drawer-toggle]');
  const closeBtn   = drawer.querySelector('[data-menu-drawer-close]');

  /* ── 開く ── */
  function openDrawer() {
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    overlay && overlay.classList.add('is-visible');
    document.body.style.overflow = 'hidden';
    toggleBtns.forEach(btn => btn.setAttribute('aria-expanded', 'true'));

    // フォーカスをドロワー先頭へ
    const firstFocusable = drawer.querySelector('button, a, [tabindex]');
    if (firstFocusable) firstFocusable.focus();
  }

  /* ── 閉じる ── */
  function closeDrawer() {
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    overlay && overlay.classList.remove('is-visible');
    document.body.style.overflow = '';
    toggleBtns.forEach(btn => btn.setAttribute('aria-expanded', 'false'));
  }

  /* ── ハンバーガーボタン（複数対応） ── */
  toggleBtns.forEach(btn => {
    btn.addEventListener('click', () => {
      drawer.classList.contains('is-open') ? closeDrawer() : openDrawer();
    });
  });

  /* ── ✕ 閉じるボタン ── */
  closeBtn && closeBtn.addEventListener('click', closeDrawer);

  /* ── オーバーレイクリックで閉じる ── */
  overlay && overlay.addEventListener('click', closeDrawer);

  /* ── Escape キーで閉じる ── */
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && drawer.classList.contains('is-open')) {
      closeDrawer();
    }
  });

})();
